import { SvgCheckCircle } from "../icons"
import React from "react"

export const planFeatures = [
  "Built-in scheduling and billing tools",
  "Customizable Zoee website",
  "Private, secure client portal",
  "Two-way SMS messaging",
  "Seamless file sharing",
  "Collect and showcase testimonials",
  "Smart digital notetaking",
  "Access to the Zoee coach network",
  "Featured on the Coach Market",
  "Exclusive events and member perks",
  "Priority support from the Zoee team",
]

const PlanInfo: React.FC = () => {
  return (
    <section className="w-full bg-white px-6 sm:px-12 py-10">
      <div className="max-w-6xl mx-auto text-center mb-8">
        <h3 className="text-2xl sm:text-3xl font-bold text-black font-['Beausite Classic']">
          All plans include everything!
        </h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 max-w-6xl mx-auto">
        {planFeatures.map((feature, index) => (
          <div key={index} className="flex items-start gap-3">
            <SvgCheckCircle className="w-5 h-5 mt-1 text-green-600 shrink-0" />
            <p className="text-gray-800 text-md font-['Beausite Classic'] leading-snug">
              {feature}
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default PlanInfo
